import React from "react";
import {Badge, ButtonGroup, ButtonGroupButton, Icon, TextField} from "peggirkit";
import {AvailableCategory} from "@/data/entities/menu";
import useMenu from "@widgets/pos/order/hooks/MenuProvider";
import {OrderEditorTabProps} from "@widgets/pos/order/OrderEditor";
import IconAddOn from "peggirkit/dist/components/Input/Field/TextField/TextFieldAddOn/IconAddOn";
import {MagnifyingGlassIcon} from "@heroicons/react/20/solid";
import ButtonAddOn from "peggirkit/dist/components/Input/Field/TextField/TextFieldAddOn/ButtonAddOn";
import {InformationCircleIcon, XMarkIcon} from "@heroicons/react/16/solid";
import {FormattedMessage, useIntl} from "react-intl";

type Props = OrderEditorTabProps & {};

const CategoriesList = ({isPending}: Props) => {
    const intl = useIntl();
    const {menuLoading, availableMenu, searchQuery, setSearchQuery} = useMenu();

    return (
        <div className={"flex flex-col gap-6"}>

            <TextField
                type={"text"}
                autoComplete={"off"}
                disabled={menuLoading}
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
                placeholder={intl.formatMessage({id: "posProductSearchPlaceholder"})}
                leading={IconAddOn({
                    icon: <Icon icon={MagnifyingGlassIcon}/>
                })}
                trailing={
                    searchQuery.length === 0
                        ? undefined
                        : ButtonAddOn({
                            position: "trailing",
                            buttonProps: {
                                iconOnly: true,
                                iconBefore: <Icon icon={XMarkIcon}/>,
                                buttonAction: {
                                    as: "button",
                                    actionProps: {
                                        onClick: e => {
                                            e.preventDefault();
                                            setSearchQuery("");
                                        },
                                    },
                                },
                            },
                        })
                }
            />

            <ButtonGroup
                vertical
                variant={"solid"}
                containerClassName={"w-full"}
            >
                {availableMenu.categories.map((category: AvailableCategory, i: number) =>
                    <ButtonGroupButton
                        key={i}
                        disabled={menuLoading || isPending}
                        buttonAction={{
                            as: "button",
                            actionProps: {
                                onClick: e => {
                                    e.preventDefault();
                                    if (!menuLoading) {
                                        document
                                            .querySelector(`div[data-category-index="${i}"]`)
                                            ?.scrollIntoView({behavior: "smooth"});
                                    }
                                }
                            },
                        }}
                    >
                        {category.name}
                        <Badge
                            color={category.sortedProducts.length > 0 ? "primary" : "secondary"}
                            size={"xs"}
                            radius={"chip"}
                            containerClassname={"absolute right-4 top-1/2 -translate-y-1/2"}
                        >
                            {category.sortedProducts.length}
                        </Badge>
                    </ButtonGroupButton>
                )}
            </ButtonGroup>

            <p className={"text-sm opacity-75"}>
                <InformationCircleIcon className={"inline size-4 mr-1 "}/>
                <FormattedMessage id={"posProductListInfo"}/>
            </p>
        </div>
    );
};

export default CategoriesList;